import axios, { AxiosError } from "axios";
import { logout } from "./Slice";
import { baseUrl } from "../Common/Constants";
import { clearIndexedDB } from "../Common/Util_methods/removeIndexdb";

const unauthorized = 401;
const forbidden = 403;
const notFound = 404;

let store;
let hasAuthenticatedOnce = false;
export const injectStore = (_store) => {
  store = _store;
};

const httpClient = axios.create({
  baseURL: baseUrl,
});

httpClient.interceptors.response.use(
    (response) => {
        if (response.status < 400) {
            hasAuthenticatedOnce = true;
        }
    return response;
  },
  async (error: AxiosError) => {
    if (error.message === "cancelled request") {
      return Promise.reject(error);
    }
    if (error.response !== undefined) {
      if (
        error.response.status !== forbidden &&
        error.response.status !== unauthorized &&
        error.response.status !== notFound
      ) {
        return Promise.reject(error);
      }
        if (error.response.status === unauthorized) {
            if (hasAuthenticatedOnce) {
              //  clearIndexedDB();
            }
        store.dispatch(logout());
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);

export default httpClient;
